$(document).ready( function() {
	'use strict';
	const $gallery = $('.masonry-gallery');

	function refreshGalleryLayout () {
		if ($gallery) $gallery.isotope('layout');
	}

	$('.expert-item-collapse').on('shown.bs.collapse', function () {
		refreshGalleryLayout();
	});

	$('.expert-item-collapse').on('hidden.bs.collapse', function () {
		refreshGalleryLayout();
	});
});
